import styled, { keyframes } from 'styled-components';
import { Tooltip } from "../../components";

export const bob = keyframes`
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-0.188rem); }
`;

export const ring = keyframes`
  from { transform: scale(1);   opacity: .5; }
  to   { transform: scale(1.9); opacity: 0; }
`;

const hexA = (hex: string, alpha: number): string => {
  const h = hex.replace('#', '');
  const bigint = parseInt(h.length === 3 ? h.split('').map((c: string) => c + c).join('') : h, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const LauncherWrap = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 3.625rem;
  height: 3.625rem;

  @media screen and (min-width: 30em) {
    width: 4rem;
    height: 4rem;
  }
`;

export const LauncherRing = styled.div<{ $primary: string }>`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: ${({ $primary }) => hexA($primary, 0.35)};
  z-index: 4;
  pointer-events: none;
  animation: ${ring} 2.2s ease-out infinite;
`;

export const LauncherButton = styled.button<{ $primary: string }>`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 5;
  padding: 0.75rem;
  box-sizing: border-box;
  background: ${({ $primary }) => $primary};
  box-shadow: 0 12px 32px ${({ $primary }) => hexA($primary, 0.5)};
  animation: ${bob} 3s ease-in-out infinite;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.96);
  }

  .anticon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  svg {
    width: 100%;
    height: 100%;
    color: ${({ $primary }) => $primary};
  }
`;

export const StyledContainer = styled(Tooltip)<{
  $closed?: boolean;
}>`
  --radius: 0.25rem;
  --inset: -0.125rem;
  position: relative;
  display: inline-flex;
  flex-direction: row-reverse;
  align-items: center;
  border-radius: var(--radius);
  background-color: transparent;
  transition: all 0.3s ease;
`;

export const StyledWrapper = styled.div`                                                                                                                     
  position: absolute;                                                                                                                                                              
  bottom: 5.25rem;                                                                                                                  
  right: 0;                                                                                                                  
  width: max-content;                                                                                                                                                              
  max-width: 16rem;   
  background: #ffffff;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 0.75rem 0.875rem;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 10; 

  ${StyledContainer}:hover & {
    opacity: 1;
    visibility: visible;
  }
`;

export const StyledInnerTooltip = styled.span`
  font-size: 0.813rem;
  line-height: 1.4;
  font-weight: 500;
  text-align: left;
`;

export const StyledIconWrapper = styled.div<{ $primary?: string }>`
  position: relative;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${({ $primary }) => $primary};
  width: 1.25rem;
  height: 1.25rem;
  padding: 0.5rem;

  .anticon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 105%;
    height: 105%;
  }

  svg {
    width: 100%;
    height: 100%;
    color: ${({ $primary }) => $primary};
  }
`;

export const AvatarBadge = styled.span<{ $primary?: string }>`
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ffffff;
  color: ${({ $primary }) => $primary || '#14A88E'};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.28);
 
  svg {
    width: 10px;
    height: 10px;
  }
`;

export const StyledWidget = styled.div`
  max-width: 30.25rem;
  width: 100%;
  display: inline-flex;
  justify-content: end;
  --main-color: #EFEEF1;
  position: relative;
`;

export const StyledChat = styled.div`
  position: relative;

  width: 100%;
  height: 90dvh;

  @media screen and (min-width: 48em) {
    height: auto;
  }
`;

export const StyledChatButton = styled.button`
  display: flex;
  justify-content: flex-start;
  width: 15.75rem;
  min-height: 2.25rem;
  gap: 0.688rem;
  color: black;
  padding: 0;
  font-size: 1rem;
  border: 0;
  cursor: pointer;
  align-items: flex-start;
  background-color: transparent;
  transition: all 0.3s ease;
`;
